<template lang="pug">
v-app.portal-app
  SnackbarProvider
    ConfirmationDialogProvider
      GalleryDashboardPortal
      CustomAttributesManagementRoot
      PortalSearch
      WebPushDialog
      InstallPWADialog
      router-view
      LevelSettings
</template>

<script lang="ts">
import Vue, { provide } from "vue"
import PortalSearch from "./PortalSearch.vue"
import WebPushDialog from "features/push/WebPushDialog.vue"
import InstallPWADialog from "features/push/InstallPWADialog.vue"
import store from "store"
import MemberService from "features/member/member.service"
import { provideGroupContext } from "features/group/groupContext"
import GalleryDashboardPortal from "features/gallery/dashboard/GalleryDashboardPortal.vue"
import CustomAttributesManagementRoot from "app/modules/custom-attributes/CustomAttributesManagementPortal.vue"
import SnackbarProvider from "app/ui-primitives/snackbars/SnackbarProvider.vue"
import ConfirmationDialogProvider from "features/common/confirmation-dialog/ConfirmationDialogProvider.vue"
import LevelSettings from "app/modules/organization/levels/LevelSettings.vue"

export default Vue.extend({
  name: "PortalApp",
  components: {
    LevelSettings,
    ConfirmationDialogProvider,
    SnackbarProvider,
    CustomAttributesManagementRoot,
    GalleryDashboardPortal,
    PortalSearch,
    WebPushDialog,
    InstallPWADialog,
  },
  setup() {
    const memberService = new MemberService(store)
    provide<MemberService>("MemberService", memberService)
    provideGroupContext()
  },
})
</script>

<style>
.portal-app {
  height: 0px !important;
  position: static;
}

/* This is necessary for iphone-compatibility with Photoswipe. Remove only, if you remove photoswipe dependency. */
.pswp__top-bar {
  margin-top: env(safe-area-inset-top);
}
</style>
